<template>
  <div :class="pageCls">
    <div class="d1"></div>
    <div class="d2">
      <div class="b1" @click="btnClick"></div>
      <div class="b2">{{onNum.length}}</div>
      <div class="b3" @click="showClick"></div>
    </div>
    <div class="d3"></div>
    <div v-if="errShow==1||errShow==2" :class="errShow==1?'d4':'d4_2'"></div>
    <div class="d5"></div>
    <div class="d6"></div>
    <div class="d7"></div>
    <div :class="oneOn==1?'d8 oned8':'d8'">
      <div :key="item" v-for="item in arr" :class="onNum.indexOf(item)==-1 ? 'b'+userData.sel1+'_'+item : 'on b'+userData.sel1+'_'+item" @click="onClick(item)"></div>
    </div>
    <div class="d9" v-show="ljtShow">
      <div :key="item" v-for="item in onNum" class="item" @click="removeClick(item)">{{tArr[userData.sel1-1][item-1]}}</div>
    </div>
    <div class="d10" v-show="pageCls.indexOf('page3_2')>0">
      <div :key="item" v-for="item in arr" :class="'icon icon_'+item+' icon'+userData.sel1+'_'+item" ></div>
    </div>
  </div>
</template>

<script>
Array.prototype.indexOf = function(val) { 
  for (var i = 0; i < this.length; i++) { 
    if (this[i] == val) return i; 
  } 
  return -1; 
};
Array.prototype.remove = function(val) { 
  var index = this.indexOf(val); 
  if (index > -1) { 
    this.splice(index, 1); 
  } 
};
const textArr = [
  [
    '嘴硬心也不咋软的死党','矫情不输黛玉的朋友','拍马屁第一名的发小','开口就为得罪人的同学','自来熟的朋友','时刻炫耀现男/女友的初恋','社交恐惧症同学','爱显摆的土豪朋友'
  ],
  ['八卦集散中心同事','办公室内卷王','凡尔赛创始人老板','用吃奶的劲儿抬杠的同事','决定年终奖的上司','人畜无害绿茶同事','不显山不露水富豪同事','越佛系越幸运同事'],
  [
    '爱女婿更爱唠叨的岳母','把我当工具人的老婆','饭桌上给你讲人生的大伯','率先光宗耀祖的兄弟姐妹','哄老人第一名的卖萌侄女','哪壶不开提哪壶还掀盖儿的三舅姥','欠钱没还的大舅子','身居要职的豪门亲戚'
  ],
];
export default {
  name: 'Page3',
  props: {
    userData: Object
  },
  data(){
    return{
      arr:[1,2,3,4,5,6,7,8],
      tArr:textArr,
      onNum:[],
      pageCls:"page3",
      ljtShow:false,
      errShow:1,
      oneOn:1,
    }
  },
  mounted(){
    let that = this;
    let temTTT;
    let temiii = 0;
    temTTT = setInterval(() => {
      // console.log(temiii)
      if(temiii > 7){
        that.oneOn = 2;
        return clearInterval(temTTT);
      }
      temiii++;
      this.$emit('playSond',"ren");
    }, 1100);
  },
  methods:{
    btnClick(){
      if(this.onNum.length < 2){
        this.errShow=1;
        return false;
      }
      for(let i=0;i<this.onNum.length;i++){
        this.arr.remove(this.onNum[i]);
      }
      this.$emit('setUser',"sel2",this.arr);
      this.pageCls = "page3 page3_2";
      setTimeout(() => {
        this.$emit('setPage',4);
      }, 1000);
    },
    onClick(n){
      if(this.onNum.indexOf(n) > -1){
        return false;
      }
      if(this.onNum.length >= 6){
        this.errShow=2;
        return false;
      }
      this.$emit('playSond',"sel");
      this.onNum.push(n);
      console.log(this.onNum)
    },
    removeClick(n){
      this.onNum.remove(n);
      if(this.onNum.length < 1){
        this.ljtShow = false;
      }
    },
    showClick(){
      if(this.onNum.length < 1){
        return false;
      }
      if(this.ljtShow){
        this.ljtShow = false;
      }else{
        this.ljtShow = true;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$time:1.1;
.page3{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  .d1{
    position: absolute;
    right:0;
    top:0;
    width: 1.8rem;
    height: 0.5rem;
    background: url(../assets/bg36.png) no-repeat 0 0 / 100% 100%;
  }
  .d2{
    position: absolute;
    left:0;
    bottom:0;
    width: 100%;
    height: 1.91rem;
    background: url(../assets/bg37.png) no-repeat 0 0 / 100% 100%;
    z-index: 10;
    .b1{
      position: absolute;
      right:0.3rem;
      top:0.5rem;
      width: 2.42rem;
      height: 0.92rem;
      background: url(../assets/bg27.png) no-repeat 0 0 / 100% 100%;
      transform: scale(1.1);
      animation:1s linear infinite transformAni;
    }
    .b2{
      position: absolute;
      left:1.88rem;
      top:0.52rem;
      width: 0.38rem;
      height: 0.38rem;
      line-height: 0.38rem;
      text-align: center;
      color:#000;
      font-size: 0.26rem;
      font-weight: bold;
    }
    .b3{
      position: absolute;
      left:0;
      top:0;
      width: 2.9rem;
      height: 1.2rem;
    }
  }
  .d3{
    position: absolute;
    right:0;
    bottom:2.17rem;
    width: 2.46rem;
    height: 2.42rem;
    background: url(../assets/bg38.png) no-repeat 0 0 / 100% 100%;
  }
  .d4{
    position: absolute;
    left:0.4rem;
    top:50%;
    width: 0.51rem;
    height: 2.28rem;
    margin:-4.45rem 0 0 0;
    background: url(../assets/bg39.png) no-repeat 0 0 / 100% 100%;
  }
  .d4_2{
    position: absolute;
    left:0.4rem;
    top:50%;
    width: 0.51rem;
    height: 6.29rem;
    margin:-4.45rem 0 0 0;
    background: url(../assets/bg102.png) no-repeat 0 0 / 100% 100%;
  }
  .d5{
    position: absolute;
    left:1.3rem;
    top:50%;
    width: 1.25rem;
    height: 3.6rem;
    margin:-2.3rem 0 0 0;
    background: url(../assets/bg40.png) no-repeat 0 0 / 100% 100%;
  }
  .d6{
    position: absolute;
    left:0.35rem;
    // bottom:1.16rem;
    width: 2.3rem;
    height: 1.75rem;
    top:50%;
    margin-top:4.5rem;
    background: url(../assets/bg66.png) no-repeat 0 0 / 100% 100%;
  }
  .d7{
    position: absolute;
    left:1.75rem;
    left:0.35rem;
    top:50%;
    width: 4.9rem;
    height: 1.61rem;
    margin:-6.17rem 0 0 0;
    background: url(../assets/bg41.png) no-repeat 0 0 / 100% 100%;
    // opacity: 0;
    // animation:$time+s linear 1 opacityAni2;
    // animation-fill-mode: forwards;
    &::after{
      content: '';
      position: absolute;
      left:1.94rem;
      top:0.63rem;
      width: 0.7rem;
      height: 0.3rem;
      background: url(../assets/bg103.png) no-repeat 0 0 / 100% 100%;
      transform: scale(0.9);
      animation:0.5s linear infinite transformAni;
    }
  }
  .oned8{
    div:nth-child(1){
      opacity: 0;
      animation:$time+s $time+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(2){
      opacity: 0;
      animation:$time+s $time*2+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(3){
      opacity: 0;
      animation:$time+s $time*3+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(4){
      opacity: 0;
      animation:$time+s $time*4+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(5){
      opacity: 0;
      animation:$time+s $time*5+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(6){
      opacity: 0;
      animation:$time+s $time*6+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(7){
      opacity: 0;
      animation:$time+s $time*7+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(8){
      opacity: 0;
      animation:$time+s $time*8+s linear 1 opacityAni2;
      animation-fill-mode: forwards;
    }
  }
  .d8{
    div{
      position: absolute;
      top:50%;
    }
    div.on{
      opacity: 1;
      animation: 1s 1 linear toLJTL,1s cubic-bezier(.6,.2,.75,.12) 1 toLJTB;
      animation-fill-mode: forwards;
      z-index: 1;
    }
    .b1_1{
      width: 3.83rem;
      height: 1.41rem;
      right: 0.25rem;
      margin-top:-4.57rem;
      background: url(../assets/bg42.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg42_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_2{
      width: 3.94rem;
      height: 1.39rem;
      right: 0.46rem;
      margin-top:-3.46rem;
      background: url(../assets/bg43.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg43_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_3{
      width: 4.24rem;
      height: 1.44rem;
      right: 0.21rem;
      margin-top:-2.36rem;
      background: url(../assets/bg44.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg44_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_4{
      width: 3.95rem;
      height: 1.5rem;
      right: 0.58rem;
      margin-top:-1.26rem;
      background: url(../assets/bg45.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg45_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_5{
      width: 3.59rem;
      height: 1.4rem;
      right: 0.21rem;
      margin-top:-0.16rem;
      background: url(../assets/bg46.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg46_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_6{
      width: 4.45rem;
      height: 1.41rem;
      right: 0.35rem;
      margin-top:0.93rem;
      background: url(../assets/bg47.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg47_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_7{
      width: 3.38rem;
      height: 1.42rem;
      right: 0.22rem;
      margin-top:2.04rem;
      background: url(../assets/bg48.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg48_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b1_8{
      width: 3.53rem;
      height: 1.39rem;
      right: 0.41rem;
      margin-top:3.13rem;
      background: url(../assets/bg49.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg49_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_1{
      width: 3.53rem;
      height: 1.41rem;
      right: 0.25rem;
      margin-top:-4.57rem;
      background: url(../assets/bg50.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg50_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_2{
      width: 3.54rem;
      height: 1.39rem;
      right: 0.46rem;
      margin-top:-3.46rem;
      background: url(../assets/bg51.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg51_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_3{
      width: 3.84rem;
      height: 1.44rem;
      right: 0.21rem;
      margin-top:-2.36rem;
      background: url(../assets/bg52.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg52_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_4{
      width: 4.05rem;
      height: 1.5rem;
      right: 0.58rem;
      margin-top:-1.26rem;
      background: url(../assets/bg53.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg53_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_5{
      width: 4.35rem;
      height: 1.4rem;
      right: 0.21rem;
      margin-top:-0.16rem;
      background: url(../assets/bg54.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg54_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_6{
      width: 4.15rem;
      height: 1.41rem;
      right: 0.35rem;
      margin-top:0.93rem;
      background: url(../assets/bg55.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg55_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_7{
      width: 4.08rem;
      height: 1.42rem;
      right: 0.22rem;
      margin-top:2.04rem;
      background: url(../assets/bg56.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg56_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b2_8{
      width: 3.33rem;
      height: 1.39rem;
      right: 0.41rem;
      margin-top:3.13rem;
      background: url(../assets/bg57.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg57_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_1{
      width: 3.93rem;
      height: 1.41rem;
      right: 0.25rem;
      margin-top:-4.57rem;
      background: url(../assets/bg58.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg58_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_2{
      width: 4.14rem;
      height: 1.4rem;
      right: 0.46rem;
      margin-top:-3.46rem;
      background: url(../assets/bg59.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg59_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_3{
      width: 4.44rem;
      height: 1.45rem;
      right: 0.21rem;
      margin-top:-2.36rem;
      background: url(../assets/bg60.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg60_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_4{
      width: 4.45rem;
      height: 1.49rem;
      right: 0.58rem;
      margin-top:-1.26rem;
      background: url(../assets/bg61.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg61_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_5{
      width: 4.85rem;
      height: 1.4rem;
      right: 0.21rem;
      margin-top:-0.16rem;
      background: url(../assets/bg62.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg62_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_6{
      width: 5.45rem;
      height: 1.4rem;
      right: 0.35rem;
      margin-top:0.93rem;
      background: url(../assets/bg63.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg63_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_7{
      width: 4.08rem;
      height: 1.41rem;
      right: 0.22rem;
      margin-top:2.04rem;
      background: url(../assets/bg64.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg64_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
    .b3_8{
      width: 3.83rem;
      height: 1.39rem;
      right: 0.41rem;
      margin-top:3.13rem;
      background: url(../assets/bg65.png) no-repeat 0 0 / 100% 100%;
      &.on{
        background: url(../assets/bg65_on.png) no-repeat 0 0 / 100% 100%;
      }
    }
  }
  .d9{
    position: absolute;
    left:0;
    bottom:0;
    width: 3.4rem;
    // height: 1.61rem;
    // margin:-6.17rem 0 0 0;
    padding:0.8rem 0 2.3rem 0;
    background: url(../assets/bg68.png) no-repeat 0 0 / 100% auto;
    .item{
      position: relative;
      margin:0 auto;
      width: 2.43rem;
      height: 0.81rem;
      line-height: 0.81rem;
      text-align: left;
      font-size: 0.22rem;
      text-indent: 0.35rem;
      // background: url(../assets/bg67.png) no-repeat 0 50% / 0.217rem 0.26rem;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      transform: scaleX(1.2);
      &::before{
        content: '';
        position: absolute;
        left:0;
        top:50%;
        width: 0.26rem;
        height: 0.26rem;
        margin-top:-0.13rem;
        background: url(../assets/bg67.png) no-repeat 0 50% / 100% 100%;
        transform: scaleX(0.83);
      }
    }
  }
}
.page3_2{
  .d1,.d2,.d3,.d4,.d5,.d6,.d7,.d8,.d9{
    // transform:translate(0);
    animation:0.2s linear 1 opacityAni;
    animation-fill-mode: forwards;
  }
  .d10{
    div{
      position: absolute;
      top:2rem;
      left: 4.5rem;
      animation:1s linear 1 iconAni1;
      animation-fill-mode: forwards;
    }
    div:nth-child(2){
      top:3.8rem;
      animation:1s linear 1 iconAni2;
      animation-fill-mode: forwards;
    }
    div:nth-child(3){
      top:5.6rem;
      animation:1s linear 1 iconAni3;
      animation-fill-mode: forwards;
    }
    div:nth-child(4){
      top:7.4rem;
      animation:1s linear 1 iconAni4;
      animation-fill-mode: forwards;
    }
    div:nth-child(5){
      top:9.2rem;
      animation:1s linear 1 iconAni5;
      animation-fill-mode: forwards;
    }
    div:nth-child(6){
      top:11rem;
      animation:1s linear 1 iconAni6;
      animation-fill-mode: forwards;
    }
  }
}
@keyframes toLJTL {
  96%{
    opacity: 1;
  }
  99%{
    transform: scale(0.2);
  }
  100%{
    right:4.3rem;
    opacity: 0;
    transform: scale(0);
  }
}
@keyframes toLJTB {
  100%{
    margin-top:4.6rem;
  }
}
@keyframes iconAni1 {
  100%{
    top:0;
    left:1.9rem;
  }
}
@keyframes iconAni2 {
  100%{
    top:0;
    left:4.08rem;
  }
}
@keyframes iconAni3 {
  100%{
    top:0;
    left:6.26rem;
  }
}
@keyframes iconAni4 {
  100%{
    top:0;
    left:8.44rem;
  }
}
@keyframes iconAni5 {
  100%{
    top:0;
    left:9rem;
  }
}
@keyframes iconAni6 {
  100%{
    top:0;
    left:9.6rem;
  }
}
</style>
